import { getMarketingBaseUrl } from "@/lib/utils";

/**
 * Absolute Next marketing URL for a public Protect path.
 * Staging and production differ via `VITE_MARKETING_URL`
 * (`https://next.reklaimyou.com` vs `https://reklaimyou.com`).
 * Called when a nav or footer module loads so a test can set the
 * marketing origin before import.
 */
export function protectMarketingUrl(path: "/protect" | "/protect-terms"): string {
  return `${getMarketingBaseUrl()}${path}`;
}
